export const SUCCESS = '----->';
export const CACHED = '->';
export const NOT_FOUND = 'NOT FOUND';
export const CONVERT = 'CONVERT';
export const ERROR = 'ERROR';
